import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgGermanFlagBlackAndWhite = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("rect", {
    y: 4,
    width: 24,
    height: 16.134,
    rx: 1.714,
    fill: "#fff"
  }), _jsx("mask", {
    id: "german-flag-black-and-white_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 24,
    height: 17,
    children: _jsx("rect", {
      y: 4,
      width: 24,
      height: 16.134,
      rx: 1.714,
      fill: "#fff"
    })
  }), _jsxs("g", {
    mask: "url(#german-flag-black-and-white_svg__a)",
    children: [_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 9.378h24V4H0v5.378Z",
      fill: "#262626"
    }), _jsx("g", {
      filter: "url(#german-flag-black-and-white_svg__b)",
      children: _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 14.756h24V9.378H0v5.378Z",
        fill: "#575757"
      })
    }), _jsx("g", {
      filter: "url(#german-flag-black-and-white_svg__c)",
      children: _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 20.134h24v-5.378H0v5.378Z",
        fill: "#CECECE"
      })
    })]
  }), _jsxs("defs", {
    children: [_jsxs("filter", {
      id: "german-flag-black-and-white_svg__b",
      x: 0,
      y: 9.378,
      width: 24,
      height: 5.378,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [_jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), _jsx("feColorMatrix", {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), _jsx("feOffset", {}), _jsx("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
      }), _jsx("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2009_62608"
      }), _jsx("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_2009_62608",
        result: "shape"
      })]
    }), _jsxs("filter", {
      id: "german-flag-black-and-white_svg__c",
      x: 0,
      y: 14.756,
      width: 24,
      height: 5.378,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [_jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), _jsx("feColorMatrix", {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), _jsx("feOffset", {}), _jsx("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
      }), _jsx("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2009_62608"
      }), _jsx("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_2009_62608",
        result: "shape"
      })]
    })]
  })]
}));
export default SvgGermanFlagBlackAndWhite;